import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '产品分类',
    links: [
      { label: '毛绒玩偶', path: '/category' },
      { label: '精致配饰', path: '/category' },
      { label: '居家好物', path: '/category' },
      { label: '文具手账', path: '/category' },
      { label: '联名限定', path: '/category' },
    ],
  },
  {
    title: '品牌信息',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '品牌故事', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '正品鉴别', path: '/article/4' },
      { label: '保养指南', path: '/article/6' },
    ],
  },
];

const FooterForm = () => {
  const formUrl = 'https://readdy.ai/api/form/d9quhksnlsngrm4lm6c0';

  return (
    <form
      data-readdy-form="newsletter-subscribe"
      action={formUrl}
      method="POST"
      encType="application/x-www-form-urlencoded"
      onSubmit={async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const honeypot = (formData.get('phone_alt') as string || '').trim();
        if (honeypot) {
          form.reset();
          return;
        }
        try {
          await fetch(formUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(formData as any).toString(),
          });
        } catch {
          // silently fail for newsletter
        }
        form.reset();
      }}
      className="flex flex-col sm:flex-row gap-2"
    >
      <input
        type="email"
        name="email"
        placeholder="输入邮箱，订阅小熊资讯"
        className="flex-1 px-4 py-2.5 rounded-lg text-sm bg-background-50 border border-background-300/60 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
        required
      />
      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="spam-guard"
      />
      <button
        type="submit"
        className="px-6 py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        订阅
      </button>
    </form>
  );
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50 pt-14 pb-8">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center">
                <i className="ri-bear-smile-line text-secondary-500 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-semibold text-background-50">
                黄油小熊
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed mb-4 max-w-sm">
              黄油小熊是当下最受欢迎的治愈系IP形象之一，集萌系外观与暖心设计于一体。关注我们，获取最新产品资讯和独家粉丝福利。
            </p>
            <div className="mb-4">
              <p className="text-sm font-medium mb-2 text-background-50/90">订阅小熊资讯</p>
              <FooterForm />
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold mb-3 text-background-50/90">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 黄油小熊 ButterBear. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="小红书">
              <i className="ri-red-packet-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}